import CustomMap from 'components/elements/customMap';
import { useModal } from 'components/elements/modal';
import { InsightService } from 'lib/apis/entity/insight';
import { useRef } from 'react';
import { FiMap } from 'react-icons/fi';
import { Layer, MapRef, Source } from 'react-map-gl';
import useHPIDetail from '../hooks/useHPIDetail';
import HousePricesDetailMapModal from './housePricesDetailMapModal';
import Maybe from '../../../elements/maybe';

const HousePricesDetailMap = () => {
  const { decode } = useHPIDetail({city:undefined,region:undefined});
  const hierarchicalResponse = InsightService.Hierarchical.useHierarchical(
    +decode!.region ? +decode!.region :
      decode!.city ? +decode!.city : 0
  );

  const data = hierarchicalResponse?.data;
  const point = data?.point;
  const polygon = data?.polygon;

  const mapRef = useRef<MapRef>(null);

  const modal = useModal({
    id: 'housePricesModal',
    closeable: false,
    content: ({ closeModal }) => {
      const locationId = decode?.region ? decode.region.toString() : decode?.city?.toString() || '';
      const locationType = decode?.region ? "REGION" : "CITY";
      return (
        <>
          <HousePricesDetailMapModal
            closeModal={closeModal}
            locationId={locationId}
            locationType={locationType}
          />
        </>
      );
    },
  });

  return (
    <div className='relative flex w-full mb-8 overflow-hidden rounded-md shadow-sm'>
      <Maybe condition={point !== null}>
        <CustomMap
          key={'market_insight_map'}
          ref={mapRef}
          initialViewState={{
            latitude: point?.coordinate[1],
            longitude: point?.coordinate[0],
            zoom: decode?.region ? 12 : 7,
          }}
          interactive={false}
          style={{ width: '100%', height: 400 }}

          latitude={point?.coordinate[1]}
          longitude={point?.coordinate[0]}
        >
          {polygon && polygon.coordinates.length > 0 && (
            <Source
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                      type: 'Polygon',
                      coordinates: [polygon.coordinates],
                    },
                  },
                ],
              }}
            >
              <Layer
                {...{
                  id: 'data',
                  type: 'fill',
                  paint: {
                    'fill-color': '#2681EF',
                    'fill-opacity': 0.3,
                  },
                }}
              />
            </Source>
          )}
        </CustomMap>
        {point && point.coordinate.length > 0 && (
          <button
            className='absolute z-10 items-center justify-center px-6 btn btn-md btn-grey-outline top-4 right-4'
            onClick={() => modal.openModal()}
          >
            <FiMap />
            نقشه حرارتی
          </button>
        )}

      </Maybe>
    </div>
  );
};

export default HousePricesDetailMap;
